import {
  insertProduct,
  getProductById,
  editProduct,
  deleteProduct,
  getAllProducts,
  addProductImage,
} from "../../../api/divvy-manageProducts";

const manageProducts = {
  namespaced: true,
  state: () => ({
    products: {},
    product: {},
    // product: {
    //   productsParent: {
    //     productid: 4953305,
    //     brand: "Best Buy",
    //     name: "Test Product 101",
    //     description: "Test Product 101",
    //     featuredescription: "Test Product 101",
    //     manufacturername: "Test Product 101",
    //     imageurl: "Test Product 101",
    //     deleted: false,
    //     whatshot: true,
    //     sourceid: null,
    //     exclude: false,
    //     supplierid: 288,
    //     searsproductparentnumber: "Test Product 102",
    //     dateadded: "2022-03-27T00:00:00Z",
    //     addedbyadminuserid: 736175,
    //     datemodified: "2022-04-13T00:00:00Z",
    //     modifiedbyadminuserid: 736175,
    //     pulsevirtueprdid: null,
    //     whatsHotClientIDs: [],
    //   },
    //   productsChildren: [
    //     {
    //       productchildid: 23072449,
    //       productid: 5059904,
    //       price: 300,
    //       available: 1,
    //       weight: 10,
    //       shippingcost: 30,
    //       deleted: false,
    //       distributersku: "P10",
    //       dateadded: "2022-03-27T00:00:00Z",
    //       addedbyadminuserid: 736175,
    //       datemodified: "2022-04-13T00:00:00Z",
    //       modifiedbyadminuserid: 736175,
    //     },
    //   ],
    // },
  }),

  getters: {
    productByID: (state) => state.product,
    allProducts: (state) => state.products,
  },

  actions: {
    fetchProductById({ commit }, params) {
      return new Promise((resolve, reject) => {
        getProductById(params)
          .then((resp) => {
            console.log(resp, "from getProductById action");
            commit("SET_PRODUCT_BY_ID", resp);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err, "from getProductById action");
          });
      });
    },
    updateProduct({ commit }, product) {
      return new Promise((resolve, reject) => {
        editProduct(product)
          .then((resp) => {
            console.log(resp, "from update product action");
            resolve(resp);
          })
          .catch(() => {
            console.log("error from update product action");
          });
      });
    },
    removeProduct({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteProduct(id)
          .then((resp) => {
            console.log(resp, "from removeProduct action");
            resolve(resp);
          })
          .catch(() => {
            console.log("error from removeProduct action");
          });
      });
    },
    addProduct({ commit }, payload) {
      return new Promise((resolve, reject) => {
        insertProduct(payload)
          .then((id) => {
            resolve(id);
          })
          .catch(() => {
            console.log("error from add Product action");
          });
      });
    },
    fetchAllProducts({ commit }, data) {
      return new Promise((resolve, reject) => {
        getAllProducts(data)
          .then((resp) => {
            commit("SET_ALL_PRODUCTS", resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            console.log(err, "from getAllProducts");
          });
      });
    },
    insertProductImage({ commit }, formData) {
      return new Promise((resolve, reject) => {
        addProductImage(formData)
          .then((status) => {
            if (status === 200) {
              resolve(status);
            }
          })
          .catch(() => {
            console.log("error from insertProductImage action");
          });
      });
    },
  },

  mutations: {
    SET_PRODUCT_BY_ID: (state, product) => {
      state.product = product;
    },
    SET_ALL_PRODUCTS: (state, data) => {
      state.products = data;
    },
  },
};

export default manageProducts;
